import * as Yup from "yup";
import { reverseShape } from "Components/shared/helpers/reverse-shape";
import {
  addressLine,
  city,
  country,
  postcode,
  state,
  validString,
} from "Components/shared/helpers/validations";

import { workingHours } from "Utils/validations";

const multipleSelect = Yup.array().min(1);

const address = Yup.object().shape(
  reverseShape({
    street1: addressLine.required(),
    street2: addressLine.optional(),
    postcode: postcode.required(),
    city: city.required(),
    state: state.required(),
    country: country.required(),
  }),
);

export const ServicePointSchema = Yup.object().shape(
  reverseShape({
    _id: validString.optional(),
    lineIDs: multipleSelect.required(),
    pointTypeID: multipleSelect.required(),
    stationCodes: multipleSelect.required(),
    locationName: validString.required(),
    address: address.required(),
    handlingInstructions: validString.optional(),
    workingHours: Yup.array()
      .of(workingHours)
      .test("workingHoursRequired", "workingHoursRequired", (values) =>
        values ? values.some((value) => value.isChecked) : false,
      ),
  }),
);
